import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import type { Location } from 'react-router-dom'
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import * as ShortlistActions from '@disco/state-management/actions/ShortlistActions'

import { getShortlistBaseRoute } from 'utils/routing'

import DocumentHeadTags from 'components/document-head-tags'
import ModalDialog from 'components/ui/modal-dialog'

const mapDispatchToProps = { ...ShortlistActions, sendMixpanelEvent }

// Define connector
const connector = connect(null, mapDispatchToProps)

// Infer props type from Redux
type PropsFromRedux = ConnectedProps<typeof connector>

// Own props interface
interface OwnProps {
  params: {
    shortlistId: string
  }
  navigate: NavigateFunction
  location: Location
}

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

class WarningMetaDataClear extends Component<Props> {
  _handleSubmit = () => {
    const { shortlistId } = this.props.params
    const baseRoute = getShortlistBaseRoute(this.props.location)
    const path = `${baseRoute}/shortlists/${shortlistId}/metadata`
    this.props.updateShortlist(shortlistId, {
      playlist_aliases: {},
      track_aliases: {},
    })
    this.props.sendMixpanelEvent('Remove alias for playlist')
    this.props.navigate(path)
    this.props.initShortlistEditedTrack(shortlistId)
  }
  _handleCancel = () => {
    const baseRoute = getShortlistBaseRoute(this.props.location)
    const path = `${baseRoute}/shortlists/${this.props.params.shortlistId}/metadata`
    this.props.navigate(path)
  }

  render() {
    return (
      <div>
        <DocumentHeadTags title="Remove alias | DISCO" />
        <ModalDialog
          title="Remove alias"
          primaryAction={{
            caption: 'Remove alias metadata',
            onClick: this._handleSubmit,
          }}
          status="danger"
          onCancel={this._handleCancel}
        >
          Are you sure you want to remove all alias metadata for this playlist?
          The playlist will be shared with its default track metadata.
        </ModalDialog>
      </div>
    )
  }
}

const ConnectedWarningMetaDataClear = connector(WarningMetaDataClear)

function WarningMetaDataClearWithNavigate(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ shortlistId: string }>()
  const location = useLocation()
  return (
    <ConnectedWarningMetaDataClear
      {...props}
      navigate={navigate}
      params={params}
      location={location}
    />
  )
}

export default WarningMetaDataClearWithNavigate
